module.exports = __webpack_public_path__ + "static/img/select_img.f87b8428.png";